var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 19.4582H7.50033C2.97533 19.4582 1.04199 17.5248 1.04199 12.9998V7.99984C1.04199 3.47484 2.97533 1.5415 7.50033 1.5415H11.667C12.0087 1.5415 12.292 1.82484 12.292 2.1665C12.292 2.50817 12.0087 2.7915 11.667 2.7915H7.50033C3.65866 2.7915 2.29199 4.15817 2.29199 7.99984V12.9998C2.29199 16.8415 3.65866 18.2082 7.50033 18.2082H12.5003C16.342 18.2082 17.7087 16.8415 17.7087 12.9998V8.83317C17.7087 8.4915 17.992 8.20817 18.3337 8.20817C18.6753 8.20817 18.9587 8.4915 18.9587 8.83317V12.9998C18.9587 17.5248 17.0253 19.4582 12.5003 19.4582Z",
    fill: "#96C3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 9.45841H15.0003C12.1503 9.45841 11.042 8.35007 11.042 5.50007V2.16674C11.042 1.91674 11.192 1.68341 11.4253 1.59174C11.6587 1.49174 11.9253 1.55007 12.1087 1.72507L18.7753 8.39174C18.9503 8.56674 19.0087 8.84174 18.9087 9.07507C18.8087 9.3084 18.5837 9.45841 18.3337 9.45841ZM12.292 3.67507V5.50007C12.292 7.65007 12.8503 8.20841 15.0003 8.20841H16.8253L12.292 3.67507Z",
    fill: "#96C3AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 11.9585H5.83301C5.49134 11.9585 5.20801 11.6752 5.20801 11.3335C5.20801 10.9918 5.49134 10.7085 5.83301 10.7085H10.833C11.1747 10.7085 11.458 10.9918 11.458 11.3335C11.458 11.6752 11.1747 11.9585 10.833 11.9585Z",
    fill: "#96C3AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 15.2915H5.83301C5.49134 15.2915 5.20801 15.0082 5.20801 14.6665C5.20801 14.3248 5.49134 14.0415 5.83301 14.0415H9.16634C9.50801 14.0415 9.79134 14.3248 9.79134 14.6665C9.79134 15.0082 9.50801 15.2915 9.16634 15.2915Z",
    fill: "#96C3AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.685de3981c200b8db5e29e541c516b27.svg";
export { ForwardRef as ReactComponent };